import React, { FC } from 'react'
import { SimpleForm, CreateProps, Edit } from 'react-admin'

import { makeStyles } from '@material-ui/core/styles'

import { FormProvider } from 'contexts/FormProvider'

import { EditForm } from './containers'

const useStyles = makeStyles({
  container: {
    padding: 8,
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
    padding: 0,
    justifyContent: 'center',
  },
})

export const EditBanner: FC<CreateProps> = (props: any) => {
  const classes = useStyles()

  return (
    <Edit className={classes.container} {...props}>
      <SimpleForm
        warnWhenUnsavedChanges
        className={classes.formContainer}
        initialValues={{
          type: 'banner-full',
          images: [
            { type: 'banner' },
            { type: 'logo' },
            { type: 'banner-mobile' },
          ],
        }}
      >
        <FormProvider>
          <EditForm />
        </FormProvider>
      </SimpleForm>
    </Edit>
  )
}
